import { SessionStorageKeys } from '~/constants/SessionStorageKeys';

/**
 * Returns the saved Shopify return params (query string) and removes them from sessionStorage.
 * Used after auth completes to navigate back to the picker with the original params.
 */
export const restoreShopifyParams = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  const saved = sessionStorage.getItem(SessionStorageKeys.ShopifyReturnParams) ?? '';

  return saved;
};

export const saveShopifyParams = (search: string): void => {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(SessionStorageKeys.ShopifyReturnParams, search);
};

export const clearShopifyParamsFromSessionStorage = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.removeItem(SessionStorageKeys.ShopifyReturnParams);
};
